import { useState, useEffect } from 'react';

export const useSortableTable = (data: unknown[] | (() => unknown[])) => {
  const [tableData, setDynamicTableData] = useState<any[]>(data);

  useEffect(() => {
    setDynamicTableData(data);
  }, [data]);
  const handleSorting = (sortField: string, sortOrder: string) => {
    if (sortField) {
      const sorted = [...tableData].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), 'en', {
            numeric: true,
          }) * (sortOrder === 'asc' ? -1 : 1)
        );
      });
      setDynamicTableData(sorted);
    }
  };
  return [tableData, handleSorting];
};
